import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.CompanyInfoPage.AdditionalServiceCardAirwallex', {
    airwallex: 'Airwallex',
    showActionMenu: 'Show action menu',
    disconnect: 'Disconnect',
    connect: 'Connect',
    reconnect: 'Reconnect',
    labelConnected: 'Connected',
    approvalWorkflowsForAirwallex: 'Approval workflows for Airwallex',
    connectedDescription:
        'Airwallex account is connected and you have access to create, approve and pay Airwallex batch payments in ApprovalMax before publishing them to Xero.',
    disconnectedDescription:
        'Connect your Airwallex account in order to create, approve and pay Airwallex batch payments in ApprovalMax before publishing them to Xero.',
    learnMore: 'Learn more',
    connectedTo: 'Connected to ',
    connectedToAirwallex: 'Connected to Airwallex',
    gotoWorkflows: 'Go to workflows',
    disconnectedFrom: 'Disconnected from ',
    warningConnectDisabled: 'Please enable Xero integration to connect your Airwallex account',
});
